import React from "react";
import Chart from "react-apexcharts";

const RevenueChart = () => {
    const options = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 5,
                columnWidth: "45%",
            },
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
        },
        yaxis: {
            labels: {
                formatter: (value) => `$${value.toLocaleString()}`,
            },
        },
        tooltip: {
            y: {
                formatter: (val) => `$${val.toLocaleString()}`,
            },
        },
        fill: {
            colors: ["#007AFF"], // Active blue color
            opacity: 0.3, // Default light opacity
        },
        states: {
            active: { filter: { type: "none" } },
            hover: { filter: { type: "none" } },
        },
    };

    const series = [
        {
            name: "Revenue",
            data: [2000, 800, 2200, 1100, 2313, 600, 1500], // Example revenue data
        },
    ];

    return (
        <>
            <Chart options={options} series={series} type="bar" height={250} />
        </>
    );
};

export default RevenueChart;
